module.exports = __webpack_public_path__ + "img/sms-sm.e709b4a9.png";